import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCESS: null,
  FAILURE: null
});